import { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { setAlert } from '../../actions/alert';
import { crearCliente } from '../../actions/clientes';

const NuevoCliente = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Clientes',
            path: '/clientes'
        },
        {
            activo: true,
            nombre: 'Nuevo cliente',
            path: '/clientes/nuevo'
        }
    ];

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [clienteData, setClienteData] = useState({
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        nacimiento: null,
        celular: null,
        email: null
    });

    /* Nuevo cliente */
    const handleInputChange = ({ target }) => {
        setClienteData({
            ...clienteData,
            [target.name]: target.value
        });
    }

    const handleDatePicker = (name, value) => {
        setClienteData({
            ...clienteData,
            [name]: value
        });
    }

    const handleGuardarCliente = async () => {
        if(clienteData.nombre){
            await dispatch(crearCliente(clienteData));

            await navigate("/clientes");
        }else{
            await dispatch(setAlert('Todos los campos son obligatorios', 'danger'));
        }
    }

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);    

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Nuevo cliente</h3>
                
                    <div className="row">
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={clienteData.nombre} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Apellido paterno" id="apellido_paterno" name="apellido_paterno" value={clienteData.apellido_paterno} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="apellido_paterno">Apellido paterno</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Apellido materno" id="apellido_materno" name="apellido_materno" value={clienteData.apellido_materno} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="apellido_materno">Apellido materno</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <DatePicker
                                        id="nacimiento"
                                        name="nacimiento"
                                        className="form-control text-center input-datepícker"
                                        dateFormat="dd/MM/yyyy"
                                        locale="es-ES"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        selected={ clienteData.nacimiento != null ? new Date(clienteData.nacimiento) : '' }
                                        onChange={ date => handleDatePicker('nacimiento', date) }
                                    />
                                    <label className="label-datepicker" htmlFor="nacimiento">Fecha de nacimiento</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Teléfono" id="celular" name="celular" value={clienteData.celular} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="celular">Teléfono</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Correo" id="email" name="email" value={clienteData.email} onChange={e => handleInputChange(e)}/>
                                    <label htmlFor="email">Correo</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button className="btn btn-success float-end" onClick={handleGuardarCliente}>Guardar</button>
                            <Link to='/clientes'><button className="btn btn-danger float-end me-2">Cancelar</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default NuevoCliente;